import { useSelector } from "react-redux";
import "./ordersBody.scss";
import type { RootState } from "../../../../../store";

interface BalanceDisplayProps {
  onClick: () => void;
  initialMargin: number;
  isReducedMargin: boolean;
  isMarginReductionCheckboxVisible: boolean;
  lots: number;
}

const BalanceDisplay: React.FC<BalanceDisplayProps> = ({
  onClick,
  initialMargin,
  isReducedMargin,
  isMarginReductionCheckboxVisible,
  lots
}) => {
  const { margin } = useSelector((state: RootState) => state.orders);
  const requiredAmount = (Number(margin?.requiredMargin) * lots).toFixed(2) ;
  const availableAmount = margin?.availableMargin?.toFixed(2);

  // now if we had isReducedMargin then only we will call the api for basket api
  return (
    <div className="d-flex gap-3 text-start">
      <div style={isMarginReductionCheckboxVisible ? { minWidth: 150 } : {}}>
        <span className="order-muted-text font-12">Required</span>
        <div className="text-color fw-bold font-14">
          {isReducedMargin ? (
            <>
              <s>{requiredAmount}</s> {(Number(initialMargin) * lots).toFixed(2)}
            </>
          ) : (
            requiredAmount
          )}
        </div>
      </div>

      <div>
        <span className="order-muted-text font-12">Available</span>
        <div className="text-color fw-bold font-14">{availableAmount}</div>
      </div>

      <div>
        <span
          onClick={onClick}
          className="order-muted-text font-12 text-primary text-blue fw-bolder clickable-text"
        >
          View Charges
        </span>
      </div>
    </div>
  );
};

export default BalanceDisplay;
